import getLocalString from "constants/Localization";
import { useUpdateJobStatusMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useUpdateJobStatus() {
  const [mutation, { loading, data, error }] = useUpdateJobStatusMutation({
    refetchQueries: ["getJob", "getJobs"],
  });

  const [updateJobStatus, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "updateJobStatus",
    },
    {
      successMessage: getLocalString("jobs.update-job-status-success"),
      failureMessage: getLocalString("jobs.update-job-status-failure"),
    }
  );

  return [updateJobStatus, context] as const;
}
